import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_SETUPFORM = createRequestTypes('ENTITIES_SETUPFORM')

export const setupform = {
  request: (setupformId) => action(ENTITIES_SETUPFORM.REQUEST, { setupformId }),
  success: (setupformId, response) => action(ENTITIES_SETUPFORM.SUCCESS, { setupformId, response }),
  failure: (setupformId, error) => action(ENTITIES_SETUPFORM.FAILURE, { setupformId, error }),
}

export const ENTITIES_SETUPFORMS = createRequestTypes('ENTITIES_SETUPFORMS')

export const setupforms = {
  request: () => action(ENTITIES_SETUPFORMS.REQUEST),
  success: response => action(ENTITIES_SETUPFORMS.SUCCESS, { response }),
  failure: error => action(ENTITIES_SETUPFORMS.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/setupform/setupform-actions.js
 **/